import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_TAGS_GUIDE } from 'shared/constants/links'
import { useTagsContext } from 'pages/settings/pages/tags/context/tagsContext'
import { useTaggedContactsContext } from 'pages/settings/pages/tags/context/taggedContactsContext'
import styles from './styles.module.scss'

export const CreateTagsButton = observer(({ className }: { className?: string }) => {
  const store = useTagsContext()

  return (
    <Button
      text='New tag'
      size='medium'
      tooltipProps={{
        label: 'You don’t have permission to create tags',
        placement: 'top',
        visibility: !store.isUserCanManageTags ? 'visible' : 'hidden',
      }}
      iconProps={{ icon: 'add' }}
      onClick={store.tagsModalStore?.handleCreate}
      className={className}
      disabled={!store.isUserCanManageTags}
    />
  )
})

export const GuideTagsButton = observer(({ className }: { className?: string }) => (
  <Button
    className={className}
    tag={'a'}
    href={LINK_TAGS_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
))

export const DeleteBulkAction = observer(() => {
  const { onBulkDelete } = useTagsContext()

  return (
    <Button
      className={styles.deleteBulk}
      text='Delete'
      icon='delete'
      typeBtn='contained'
      contained='tertiary'
      size='small'
      onClick={onBulkDelete}
    />
  )
})

export const DeleteContactsBulkAction = observer(() => {
  const { onBulkDelete } = useTaggedContactsContext()

  return (
    <Button
      className={styles.deleteBulk}
      text='Remove tag'
      icon='delete'
      typeBtn='contained'
      contained='tertiary'
      size='small'
      onClick={onBulkDelete}
    />
  )
})

export const RenameTagAction = observer(() => {
  const { onTagRename, isUserCanManageTags } = useTaggedContactsContext()

  return (
    <Button
      text='Rename'
      icon='edit'
      typeBtn='contained'
      contained='secondary'
      size='medium'
      tooltipProps={{
        label: 'You don’t have permission to rename tags',
        placement: 'top',
        visibility: !isUserCanManageTags ? 'visible' : 'hidden',
      }}
      onClick={onTagRename}
      disabled={!isUserCanManageTags}
    />
  )
})

export const DeleteTagAction = observer(() => {
  const { onTagDelete, isUserCanManageTags } = useTaggedContactsContext()

  return (
    <Button
      text='Delete'
      icon='delete'
      typeBtn='contained'
      contained='secondary'
      size='medium'
      tooltipProps={{
        label: 'You don’t have permission to delete tags',
        placement: 'top',
        visibility: !isUserCanManageTags ? 'visible' : 'hidden',
      }}
      onClick={onTagDelete}
      disabled={!isUserCanManageTags}
    />
  )
})
